import './style.scss';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateUser } from '../login/actions';
import AccountDetails from './accountDetails';
import Payment from './payment';
import Promos from './promos';
import { NarrowContainer } from 'scy/layouts';
import { AccentH5 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import { pageContainer } from 'scy/utils.mod.scss';
import { LightBackground } from 'scy/Background';
import styles from './styles.mod.scss';

function AccountPage() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.login.user);
  const isVerified = user && user.mobileVerified;

  return (
    <NarrowContainer className={pageContainer}>
      <Section title="Account Details">
        <AccountDetails
          user={user}
          updateUser={data => dispatch(updateUser(data))}
        />
      </Section>
      {isVerified && (
        <Section title="Payment Methods">
          <Payment />
        </Section>
      )}
      <Section title="Promos & Gift Cards">
        <Promos />
      </Section>
    </NarrowContainer>
  );
}

function Section({ title, children }) {
  return (
    <section className={styles.section}>
      <AccentH5
        uppercase
        tag="h1"
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        {title}
      </AccentH5>
      <LightBackground className={styles.card}>{children}</LightBackground>
    </section>
  );
}

export default AccountPage;
